export const MESSAGE_TYPES = {
  standard: "Standard",
  interactive: "Interactive",
  interactivePledge: "InteractivePledge",
  textToPledge: "TextToPledge",
  fundraising: "Fundraising",
  optOut: "Opt-out",
  optIn: "Opt-in",
  accountvCard: "vCard",
  confirmationText: "CventConfirmationText",
};

export const BUSINESS_DOMAIN = {
  givbeeMain: "GivBeeMain",
  eventText: "EventText",
  dpText: "DPText",
};

export const SUBSCRIPTION_TYPES = {
  payDaily: "Daily",
  payMonthly: "Monthly",
  payYearly: "Yearly",
  payOnetime: "Onetime",
  customOnetime: "CustomOnetime",
  customYearly: "CustomYearly",
  customMonthly: "CustomMonthly",
  legacyOnetime: "LegacyOntime",
  legacyMonthly: "LegacyMonthly",
  legacyYearly: "LegacyYearly",
};
